import {GetSafeValue} from "../../utils/get-safe-value";

export class PairVariant {
  private _key: string;
  private _value: string;

  constructor() {
    this.key = '';
    this.value = '';
  }

  fromJson(data: PairVariant){
    this.key = GetSafeValue.getSafeValueAsString(data['key'], null);
    this.value = GetSafeValue.getSafeValueAsString(data['value'], null);
  }

  static clone(data: PairVariant){
    return Object.assign(new PairVariant(), data);
  }

  get key(): string {
    return this._key;
  }

  set key(value: string) {
    if(value && value !== "" && value != null) {
      this._key = value;
    }else {
      this._key = null;
    }
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    if(value && value !== "" && value != null) {
      this._value = value;
    }else {
      this._value = null;
    }
  }
}

export class WeightVariant {
  private _unit: string;
  private _value: number;

  constructor() {
    this.unit = '';
    this.value = 0;
  }

  fromJson(data: WeightVariant){
    this.unit = GetSafeValue.getSafeValueAsString(data['unit'], null);
    this.value = GetSafeValue.getSafeValueAsNumber(data['value'], null);
  }

  static clone(data: WeightVariant){
    return Object.assign(new WeightVariant(), data);
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    if(value && value !== "") {
      this._unit = value;
    }else {
      this._unit = null;
    }
  }

  get value(): number {
    return this._value;
  }

  set value(value: number) {
    if(value) {
      this._value = value;
    }else {
      this._value = null;
    }
  }
}
